import React, { Fragment } from 'react';
import LoginModal from '../../LoginModal';
import { useState, useEffect } from 'react';
import { authActions } from '../../../store/auth-slice';
import { dealAction } from '../../../store/deal-slice';
import NavItem from '../../Atoms/NavItem/index';
import FaBars from '@meronex/icons/fa/FaBars';
import FaTimes from '@meronex/icons/fa/FaTimes';
import { getConfig, routePathMap } from '../../../utils/config';
import setAuthToken from '../../../utils/authtoken';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { getFormattedUserName } from '../../../helpers';
import { deleteWinnreAuthToken, winnreNoAuth } from '../../../utils/axios';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { coinSvg, giftBoxSvg, profileSvg } from '../../../commonSVG';

const formatCoins = (num) => {
    if (!num) return 0;

    if (num >= 1000) {
        return (num / 1000).toFixed(1).replace('.0', '') + 'K';
    }

    return num;
};

// The `faq` value comes off the API, so normalise it before handing it to
// window.open: allow same-origin paths and http(s) URLs, add a scheme when the
// backend sends a bare host, and reject anything else (javascript:, data:, ...).
const resolveFaqUrl = (value) => {
    if (typeof value !== 'string') return null;

    const url = value.trim();
    if (!url) return null;

    if (url.startsWith('/')) return url;

    if (/^[a-z][a-z0-9+.-]*:/i.test(url)) {
        return /^https?:\/\//i.test(url) ? url : null;
    }

    return `https://${url}`;
};

const Overlay = ({ visible }) => {
    return (
        <div
            className={
                'fixed z-30 inset-0 bg-gray-700 bg-opacity-60 overflow-y-auto h-full w-full' +
                (visible ? ' block' : ' hidden')
            }
            id="my-modal"
        ></div>
    );
};

function NavBar({ navBarConfig, setOpenMobileDropdown, cartCount = 0 }) {
    const config = getConfig();
    const isGodrej =
        config?.clientId ===
        'a5f774aefbfdad058bae1f580a2295ee5ea319cd0eb94833db348e5815e77826';
    const history = useHistory();
    const [showNavBar, setShowNavBar] = useState(false);
    const [showMMenu, setShowMMenu] = useState(false); //s
    const [clicked, setClicked] = useState(false); //s
    const [openMyProfile, setOpenMyProfile] = useState(false);
    const [hideLogin, setHideLogin] = useState(false);
    const [isCartVisible, setIsCartVisible] = useState(false);
    const [faqUrl, setFaqUrl] = useState(null);

    const dispatch = useDispatch();
    const location = useLocation();
    const { userName, userRole, isAuthenticated, isLoginModalVisible } =
        useSelector((state) => state.auth);
    const totalRewardspoint = useSelector((state) => state.auth.rewardPoints);
    const reloyRewardPoints = useSelector(
        (state) => state.auth.reloyRewardPoints
    );

    useEffect(() => {
        window.addEventListener('scroll', transitionNavBar);

        return () => {
            window.removeEventListener('scroll', transitionNavBar);
        };
    }, []);
    useEffect(() => {
        if (location.pathname.includes('/surveyform')) setHideLogin(true);
    }, [location.pathname]);

    useEffect(() => {
        const isRewardStoreRoute = location?.pathname
            ?.toLowerCase()
            ?.includes('/rewardpointstore');
        setIsCartVisible(isRewardStoreRoute);
    }, [location.pathname]);

    // Drives the FAQ nav button: the button only renders once we know the
    // summary response actually carries a usable `faq` link.
    useEffect(() => {
        let mounted = true;

        winnreNoAuth
            .get('/winnre/user/about/summary?appType=WINNRE')
            .then((res) => {
                if (!mounted) return;
                setFaqUrl(resolveFaqUrl(res?.faq));
            })
            .catch(() => {
                if (!mounted) return;
                setFaqUrl(null);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };

    const openFaq = () => {
        if (!faqUrl) return;
        window.open(faqUrl, '_blank', 'noopener,noreferrer');
    };
    // console.log('render navbar');
    const logout = () => {
        // localStorage.removeItem('token');
        if (config?.autoLogout) {
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('accessToken');
        } else {
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('accessToken');
            localStorage.removeItem('cartData_reloyrewardpoints');
        }
        // setAuthToken(false);
        window?.webengage?.track('LogOut');
        window?.webengage?.user?.logout();
        deleteWinnreAuthToken();
        dispatch(authActions.logout());
    };

    const handleClicks = () => {
        setClicked((prevState) => !prevState);

        if (clicked) {
            setShowMMenu(false);
        } else {
            setShowMMenu(true);
        }
    };

    const setClickFalse = () => {
        setClicked(false);
        setShowMMenu(false);
    };

    const transitionNavBar = () => {
        // alert(window.scrollY);
        if (window.scrollY > 100) {
            setShowNavBar(true);
        } else {
            setShowNavBar(false);
        }
    };

    const handleCartClick = () => {
        if (cartCount > 0) {
            dispatch(dealAction.setCartModalVisible(true));
            window?.webengage?.track('DealViewedInCart');
            window.dispatchEvent(new Event('cartUpdated'));
        }
    };

    const routeList = window.reloy_env.client_config.NAVIGATION_ROUTES;

    return (
        <>
            {/* {isLoginModalVisible && <LoginModal />} */}
            {showMMenu && <Overlay visible={showMMenu} />}
            {!window.reloy_env.WEBFORM_ONLY && (
                <header
                    className={
                        `flex justify-between items-center top-0 w-full sticky z-30 ${showNavBar
                            ? config.navBarConfig.stickyHeight
                                ? config.navBarConfig.stickyHeight
                                : config.navBarConfig.height || 'h-20 '
                            : config.navBarConfig.height || 'h-20 '
                        }  ${config.navBarConfig?.font || 'font-Roboto'} ` +
                        (showNavBar
                            ? ` ${config?.navBarConfig.stickyNavBar
                                .backgroundColor || 'bg-primary-content'
                            }  ${config?.navBarConfig.stickyNavBar.border
                                ? `${config?.navBarConfig.stickyNavBar.borderClass}`
                                : ``
                            } 
                              ${config?.navBarConfig.stickyNavBar.height
                                ? `${config?.navBarConfig.stickyNavBar.height}`
                                : `${config.navBarConfig.height}`
                            } `
                            : ` ${config.navBarConfig.baseNavBar
                                .backgroundColor || 'bg-transparent'
                            } ${config?.navBarConfig.baseNavBar.border
                                ? `${config?.navBarConfig.baseNavBar.borderClass}`
                                : ''
                            }
                              ${config?.navBarConfig.baseNavBar.height
                                ? `${config?.navBarConfig.baseNavBar.height}`
                                : `${config.navBarConfig.height}`
                            }
                     
                           `) +
                        (showNavBar
                            ? `${config?.navBarConfig.stickyNavBar
                                .backgroundColor || 'bg-primary-content'
                            }`
                            : ``)
                    }
                >
                    {/* Logo */}
                    <Link to="/">
                        <div className="self-center">
                            <img
                                className={
                                    '  object-contain cursor-pointer ' +
                                    (showNavBar
                                        ? `${config.logoLeft
                                            ?.stickyNavBarLogoClass ||
                                        ' h-7 xl:h-10 2xl:h-20 mt-2 ml-2'
                                        }`
                                        : `${config.logoLeft
                                            ?.baseNavBarLogoClass ||
                                        ' h-7 xl:h-10 2xl:h-20 top-4 2xl:top-10 left-4'
                                        }`)
                                }
                                src={
                                    showNavBar
                                        ? config?.logoLeft?.stickyUrl ||
                                        config?.logoLeft?.url
                                        : config?.logoLeft?.baseUrl ||
                                        config?.logoLeft?.url
                                }
                                alt={config.logoLeft?.name || 'BrandLogo'}
                            />
                        </div>
                    </Link>
                    {!hideLogin && (
                        <div>
                            <div className="flex ">
                                {/* {isAuthenticated && (
                                    <div
                                        class="lg:hidden relative inline-block "
                                        onMouseOver={() =>
                                            setOpenMyProfile(true)
                                        }
                                        onMouseLeave={() =>
                                            setOpenMyProfile(false)
                                        }
                                    >
                                        <button
                                            className={
                                                'flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                (showNavBar
                                                    ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                    : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                            }
                                        >
                                            {getFormattedUserName(userName)}
                                        </button>
                                    </div>
                                )} */}
                                {/* Mobile Toggle Icon */}

                                {isAuthenticated && isCartVisible && (
                                    <button
                                        onClick={handleCartClick}
                                        className={`relative lg:hidden text-left border-none w-auto mr-1 mb-2`}
                                    >
                                        <svg
                                            fill="currentColor"
                                            viewBox="0 0 22.427 25.887"
                                            className={`w-5 -mb-1 ${config?.navBarConfig.mobileIconColor}`}
                                        >
                                            <g
                                                id="bag"
                                                transform="translate(-3.005 -0.995)"
                                            >
                                                <path
                                                    id="Path_7704"
                                                    data-name="Path 7704"
                                                    d="M25.427,21.792,23.864,6.771A2.583,2.583,0,0,0,21.291,4.45H18.444a4.314,4.314,0,0,0-8.455,0H7.142A2.581,2.581,0,0,0,4.57,6.77L3,21.792v.086a5.01,5.01,0,0,0,5,5H20.428a5.01,5.01,0,0,0,5-5A.767.767,0,0,0,25.427,21.792ZM14.217,2.725A2.593,2.593,0,0,1,16.657,4.45H11.776a2.593,2.593,0,0,1,2.441-1.726Zm6.212,22.432H8A3.279,3.279,0,0,1,4.726,21.92L6.286,6.952a.863.863,0,0,1,.856-.776H21.291a.863.863,0,0,1,.863.776L23.707,21.92a3.278,3.278,0,0,1-3.278,3.236Z"
                                                    transform="translate(0 0)"
                                                />
                                                <path
                                                    id="Path_7705"
                                                    data-name="Path 7705"
                                                    d="M18.765,11a.863.863,0,0,0-.863.863,2.588,2.588,0,0,1-5.177,0,.863.863,0,1,0-1.726,0,4.314,4.314,0,0,0,8.628,0A.863.863,0,0,0,18.765,11Z"
                                                    transform="translate(-1.097 -1.373)"
                                                />
                                            </g>
                                        </svg>
                                        <span className="absolute w-[20px] h-[20px] border rounded-xl bottom-[10px] text-center bg-primary text-white left-[10px] text-xs font-medium">
                                            {cartCount}
                                        </span>
                                    </button>
                                )}

                                <div
                                    onClick={handleClicks}
                                    className={`block lg:hidden self-center mr-4 z-30 ${config?.navBarConfig.mobileIconColor}`}
                                >
                                    {clicked ? <FaTimes /> : <FaBars />}
                                </div>
                            </div>
                            {/* Nav */}
                            <ul
                                className={
                                    'bg-primary-content self-center lg:bg-transparent flex-row w-full lg:w-auto h-auto l-2 opacity-100 absolute flex right-0 lg:left-0 lg:relative py-4 top-0 justify-start lg:justify-end lg:block  ' +
                                    (showMMenu
                                        ? 'visible transition md:text-lg ease-in'
                                        : 'invisible lg:visible transition ease-in ') +
                                    (showNavBar
                                        ? `${config?.navBarConfig.stickyNavBar
                                            .containerClass ||
                                        config?.navBarConfig.baseNavBar
                                            .containerClass ||
                                        ' md:text-lg min-w-full'
                                        }`
                                        : `${config?.navBarConfig.baseNavBar
                                            .containerClass ||
                                        ' md:text-lg min-w-full'
                                        }`)
                                }
                            >
                                <li
                                    className="lg:text-center"
                                    onClick={setClickFalse}
                                >
                                    {/* {Object.keys(routeList)
                                .sort(
                                    (a, b) =>
                                        routeList[a].order - routeList[b].order
                                )
                                .map((page) => (
                                    <NavItem
                                        key={routeList[page].name}
                                        label={routeList[page].name}
                                        show={routeList[page].show}
                                        pathname={
                                            routeList[page].path ||
                                            routePathMap[page] ||
                                            '/'
                                        }
                                        scrollTo={routeList[page].scrollTo}
                                        customUrl={routeList[page].customUrl}
                                        showNavBar={showNavBar}
                                        showMMenu={showMMenu}
                                        setOpenMobileDropdown={
                                            setOpenMobileDropdown
                                        }
                                    />
                                ))} */}

                                    {config?.customHomePage && (
                                        <button
                                            onClick={() => history.push('/')}
                                            className={
                                                'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                (showNavBar
                                                    ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                    : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                            }
                                        >
                                            OVERVIEW
                                        </button>
                                    )}
                                    {routeList &&
                                        routeList.PROJECTS?.show &&
                                        isAuthenticated && (
                                            <button
                                                onClick={() =>
                                                    history.push(
                                                        routeList.PROJECTS
                                                            .path || '/projects'
                                                    )
                                                }
                                                className={
                                                    'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                    (showNavBar
                                                        ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                                }
                                            >
                                                PROJECTS
                                            </button>
                                        )}
                                    {routeList &&
                                        routeList.OFFERS?.show &&
                                        isAuthenticated && (
                                            <button
                                                onClick={() =>
                                                    history.push(
                                                        routeList.OFFERS.path ||
                                                        '/deals'
                                                    )
                                                }
                                                className={
                                                    'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                    (showNavBar
                                                        ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                                }
                                            >
                                                DEALS
                                            </button>
                                        )}

                                    {config?.showAgreement &&
                                        !isAuthenticated && (
                                            <button
                                                className={
                                                    'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                    (showNavBar
                                                        ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                                }
                                                onClick={openLoginModal}
                                            >
                                                Sign Agreement
                                            </button>
                                        )}
                                    {isAuthenticated && (
                                        <NavLink
                                            className={
                                                `px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                                (showNavBar
                                                    ? `${config?.navBarConfig
                                                        .stickyNavBar
                                                        .itemClass ||
                                                    'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                    }`
                                                    : ` ${config.navBarConfig
                                                        .baseNavBar
                                                        .itemClass ||
                                                    'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                    }`)
                                            }
                                            activeClassName={
                                                config.navBarConfig
                                                    .showActiveLinkColor
                                                    ? 'text-secondary-focus'
                                                    : ''
                                            }
                                            to="/myprofile/info"
                                        >
                                            My Profile
                                        </NavLink>
                                    )}

                                    {isAuthenticated && (
                                        <button
                                            onClick={logout}
                                            className={
                                                `px-6 py-2 block lg:hidden transition ease-out duration-75  ` + //Common class for mobnavbar and navbar
                                                (showNavBar
                                                    ? `${config?.navBarConfig
                                                        .stickyNavBar
                                                        .itemClass ||
                                                    'text-secondary-focus text-[10px] xl:text-base 2xl:text-[15px] lg:mr-12 xl:mr-14'
                                                    }`
                                                    : ` ${config.navBarConfig
                                                        .baseNavBar
                                                        .itemClass ||
                                                    'text-primary lg:text-[10px] xl:text-[13px] 2xl:text-[13px]'
                                                    }`)
                                            }
                                            activeClassName={
                                                config.navBarConfig
                                                    .showActiveLinkColor
                                                    ? 'text-secondary-focus'
                                                    : ''
                                            }
                                        >
                                            Logout
                                        </button>
                                    )}
                                    {faqUrl &&
                                        routeList &&
                                        routeList.FAQ?.show && (
                                            <button
                                                onClick={openFaq}
                                                className={`text-left px-6 w-full py-2 lg:p-0 lg:border-none lg:w-auto lg:mr-6  ${showNavBar
                                                        ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                                    }  `}
                                            >
                                                {routeList.FAQ?.name || 'FAQ'}
                                            </button>
                                        )}
                                    {!isAuthenticated && (
                                        <button
                                            onClick={openLoginModal}
                                            className={`text-left px-6 w-full py-2 lg:p-0 lg:border-none lg:w-auto lg:mr-6  ${showNavBar
                                                    ? ` ${config.navBarConfig.stickyNavBar.itemClass}`
                                                    : ` ${config.navBarConfig.baseNavBar.itemClass}`
                                                }  `}
                                        >
                                            Login
                                        </button>
                                    )}

                                    {isAuthenticated && (
                                        <div
                                            class="hidden lg:relative lg:inline-block "
                                            onMouseOver={() =>
                                                setOpenMyProfile(true)
                                            }
                                            onMouseLeave={() =>
                                                setOpenMyProfile(false)
                                            }
                                        >
                                            <button
                                                className={
                                                    'uppercase flex flex-row items-center px-6 py-2 2xl:px-2 2xl:py-2 lg:pb-2 lg:border-none lg:mr-7 lg:px-0 lg:inline-block transition ease-out duration-75 w-full md:w-auto md:inline ' +
                                                    (showNavBar
                                                        ? `${config?.navBarConfig.stickyNavBar.itemClass}`
                                                        : ` ${config.navBarConfig.baseNavBar.itemClass}`)
                                                }
                                            >
                                                {getFormattedUserName(userName)}

                                                <svg
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                    class={
                                                        `${openMyProfile
                                                            ? ' rotate-180'
                                                            : ' rotate-0'
                                                        }` +
                                                        ' inline w-4 h-4 mt-1 ml-1 transition-transform duration-200 transform md:-mt-1'
                                                    }
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                        clipRule="evenodd"
                                                    ></path>
                                                </svg>
                                            </button>

                                            {openMyProfile && (
                                                <div
                                                    class={`z-20 lg:absolute right-0 w-full transition-opacity duration-300  origin-top-right lg:rounded-md lg:shadow-lg md:w-48 `}
                                                >
                                                    <div
                                                        class={`px-2 lg:rounded-md lg:shadow ${userRole ===
                                                                'CUSTOMER'
                                                                ? 'lg:py-4'
                                                                : ''
                                                            } ${config?.navBarConfig
                                                                .dropDownBg
                                                                ? config
                                                                    ?.navBarConfig
                                                                    .dropDownBg
                                                                : 'bg-white'
                                                            }`}
                                                    >
                                                        <NavLink
                                                            to="/myprofile/docs"
                                                            className={` py-2 block px-4 bg-transparent rounded-lg md:mt-0 ${config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownItemClass
                                                                }  ${config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownContainerClass
                                                                    ? config
                                                                        ?.navBarConfig
                                                                        .baseNavBar
                                                                        .dropDownContainerClass
                                                                    : 'hover:text-gray-900 hover:bg-gray-200'
                                                                } `}
                                                        >
                                                            MY PROFILE
                                                        </NavLink>

                                                        {/*    <NavLink
                                                            to="/myprofile/rewardPoints"
                                                            className={` py-2 block px-4 bg-transparent rounded-lg md:mt-0 ${
                                                                config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownItemClass
                                                            }  ${
                                                                config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownContainerClass
                                                                    ? config
                                                                          ?.navBarConfig
                                                                          .baseNavBar
                                                                          .dropDownContainerClass
                                                                    : 'hover:text-gray-900 hover:bg-gray-200'
                                                            } `}
                                                        >
                                                            INSIDER COINS
                                                        </NavLink> */}
                                                        {/* )} */}
                                                        <a
                                                            onClick={logout}
                                                            className={`block px-4 py-2 bg-transparent rounded-lg md:mt-0 cursor-pointer ${config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownItemClass
                                                                }  ${config
                                                                    ?.navBarConfig
                                                                    .baseNavBar
                                                                    .dropDownContainerClass
                                                                    ? config
                                                                        ?.navBarConfig
                                                                        .baseNavBar
                                                                        .dropDownContainerClass
                                                                    : 'hover:text-gray-900 hover:bg-gray-200'
                                                                } `}
                                                        >
                                                            LOGOUT
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {isAuthenticated && isCartVisible && (
                                        <button
                                            onClick={handleCartClick}
                                            className="relative hidden lg:inline-block align-middle mr-2"
                                        >
                                            <svg
                                                fill="currentColor"
                                                viewBox="0 0 22.427 25.887"
                                                className={`${showNavBar ? config?.navBarConfig.stickyNavBar.itemClass : config?.navBarConfig.baseNavBar.itemClass} w-5`}
                                            >
                                                <g
                                                    id="bag"
                                                    transform="translate(-3.005 -0.995)"
                                                >
                                                    <path
                                                        id="Path_7704"
                                                        data-name="Path 7704"
                                                        d="M25.427,21.792,23.864,6.771A2.583,2.583,0,0,0,21.291,4.45H18.444a4.314,4.314,0,0,0-8.455,0H7.142A2.581,2.581,0,0,0,4.57,6.77L3,21.792v.086a5.01,5.01,0,0,0,5,5H20.428a5.01,5.01,0,0,0,5-5A.767.767,0,0,0,25.427,21.792ZM14.217,2.725A2.593,2.593,0,0,1,16.657,4.45H11.776a2.593,2.593,0,0,1,2.441-1.726Zm6.212,22.432H8A3.279,3.279,0,0,1,4.726,21.92L6.286,6.952a.863.863,0,0,1,.856-.776H21.291a.863.863,0,0,1,.863.776L23.707,21.92a3.278,3.278,0,0,1-3.278,3.236Z"
                                                        transform="translate(0 0)"
                                                    />
                                                    <path
                                                        id="Path_7705"
                                                        data-name="Path 7705"
                                                        d="M18.765,11a.863.863,0,0,0-.863.863,2.588,2.588,0,0,1-5.177,0,.863.863,0,1,0-1.726,0,4.314,4.314,0,0,0,8.628,0A.863.863,0,0,0,18.765,11Z"
                                                        transform="translate(-1.097 -1.373)"
                                                    />
                                                </g>
                                            </svg>
                                            <span className="absolute w-[20px] h-[20px] border rounded-xl -top-2 left-[10px] text-center bg-primary text-white text-xs font-medium">
                                                {cartCount}
                                            </span>
                                        </button>
                                    )}
                                </li>
                            </ul>
                        </div>
                    )}
                </header>
            )}
        </>
    );
}

export default NavBar;
